<template>
  <div class="void-item w-[284] mr-[44] mb-[34]">
    <div class="flex justify-between pb-[8]">
      <div class="t-[#606266] t-[14] leading-[16] text-center"><span v-if="required" style="color: red">* </span>{{
        typeName }}</div>
      <div class="flex">
        <slot name="open_list"></slot>
        <!-- <div class="void-upload text-center mr-[12]">
          <p class="t-[theme] cursor-pointer">
              <i class="icon ml-[4] t-[12]">&#xe684;</i>
              <span class="t-[12]">生成列表选择</span>
            </p>
        </div> -->
        <div class="void-upload text-center">
          <dg-upload2 :type="type" :size="100" :attrs="{ key: keyVal, name: '', code: k, enable: true, new: true }"
            v-model="localList" @fileError="fileError" @before="handleLoading" @after="handleNoLoading">
            <p class="t-[theme] cursor-pointer">
              <i class="icon ml-[4] t-[12]">&#xe74e;</i>
              <span class="t-[12]">上传</span>
            </p>
          </dg-upload2>
        </div>
      </div>

    </div>
    <div class="msg">
      <div v-if="this.$route.query.taction == 'CourtLowsuitInsure'">
        <div
          v-if="visibleList[k] && visibleList[k].showMsg && (!visibleList[k].contentVerify || !visibleList[k].signVerify)"
          class="h-[28] bg-[#FFF6EB] t-[11] t-[#FFA530] px-[20] flex items-center">
          <!-- <div class="h-[28] bg-[#FFF6EB] t-[11] t-[#FFA530] flex items-center"> -->
          <div class="h-[28] bg-[#FFF6EB] t-[11] t-[#FFA530] px-[20] flex items-center">
            <i class="el-icon-warning mr-[4] t-[11]"></i>
            <!-- <span>文件内容或不符，且缺少签字/盖章</span> -->
            <span v-if="!visibleList[k].contentVerify && !visibleList[k].signVerify">文件内容或不符，且缺少签字/盖章</span>
            <span v-if="!visibleList[k].contentVerify && visibleList[k].signVerify">文件内容或不符</span>
            <span v-if="visibleList[k].contentVerify && !visibleList[k].signVerify">文件或缺少签字/盖章</span>
          </div>
        </div>
      </div>

    </div>
    <div class="p-[12] bg-[#fafafc]">
      <div class="void-content" v-loading="loading">
        <div v-for="(v, index) in localList" :key="index" class="">
          <!-- <template v-if="!v.voidCheckbox"> -->
          <div class="flex justify-between mb-[8]" v-if="v.hasOwnProperty('enable') && !v.new"
            :class="{ void: !v.enable && !v.new }">
            <a class="cursor-pointer w-[80%] truncate no-underline !t-[theme]" :href="v[keyVal]" target="_blank">{{
              `${typeName}${index + 1}` }}</a>
            <el-checkbox v-if="v.enable" :label="checkbox + v.id"></el-checkbox>
          </div>
          <div class="flex justify-between mb-[8]" v-else>
            <a class="cursor-pointer w-[80%] truncate no-underline !t-[theme]" :href="v[keyVal]" target="_blank">{{ k ==
              'OTHER' ? v.name :
              `${typeName}${index + 1}` }}</a>
            <el-button type="text" icon="el-icon-close" class="aui-padded" @click="remove(localList, v)"></el-button>
          </div>
          <!-- </template> -->
          <!-- <template v-else>
          <template v-if="v.enable">
            <div class="flex justify-between mb-[8]" v-if="v.hasOwnProperty('enable') && !v.new"
              :class="{ void: !v.enable && !v.new }">
              <a class="cursor-pointer w-[80%] truncate no-underline !t-[theme]" :href="v[keyVal]" target="_blank">{{
                `${typeName}${index + 1}` }}</a>
              <el-checkbox v-if="v.enable" :label="checkbox + v.id"></el-checkbox>
            </div>
            <div class="flex justify-between mb-[8]" v-else>
              <a class="cursor-pointer w-[80%] truncate no-underline !t-[theme]" :href="v[keyVal]" target="_blank">{{
                `${typeName}${index + 1}` }}</a>
              <el-button type="text" icon="el-icon-close" class="aui-padded" @click="remove(localList, v)"></el-button>
            </div>
          </template>
        </template> -->
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { remove } from "../assets/js/utils";
export default {
  name: "dg-void",
  inject: [],
  props: {
    visibleList: {
      type: Object,
      default: () => {
        return {
          QI_SU_ZHUANG: {},
          BAO_QUAN_SHEN_QING_SHU: {},
        }
      }
    },
    required: {
      type: Boolean,
      default: false,
    },
    // 对应的对象名
    k: {
      default: "",
    },
    //复选框key
    checkbox: {
      default: "",
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    typeName: {
      type: String,
      default: "",
    },
    keyVal: {
      type: String,
      default: "value",
    },
    type: {
      type: Array,
      default: () => {
        return [".jpg", ".jpeg", ".png", '.pdf', '.docx', '.doc'];
      },
    },
  },
  data() {
    return {
      refineForm: {},
      loading: false,
      url: "",
      localList: [], // 新增本地数据属性
      tips: "仅限上传一张图片，大小不超过5M",
    };
  },
  watch: {
    list: {
      immediate: true,
      handler(newVal) {
        this.localList = newVal;
      },
    },
    localList: {
      handler(newVal) {
        this.$emit("update:list", newVal);
        this.$emit("updateList", newVal, this.k);
      },
    },
  },
  methods: {
    remove,
    handleLoading() {
      this.loading = true;
    },
    handleNoLoading() {
      this.loading = false;
    },
    fileError(msg) {
      this.$emit("fileError", msg);
    },
    selectFile(item) {
      if (item.path) {
        window.fixOpen(item.path);
      } else {
        window.fixOpen(item.value);
      }
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.void-item {
  .msg {
    border-top: 1px solid #c3cad9;
  }

  .void-content {
    color: #0048ff;
    background: #fafafc;
    height: 147px;
    font-size: 14px;
    line-height: 16px;
    overflow-y: auto;
    // padding: 12px;
    // border-top: 1px solid #c3cad9;

    &::-webkit-scrollbar {
      /* 血槽宽度 */
      width: 3px;
      height: 3px;
    }

    /deep/ .el-checkbox__label {
      display: none !important;
    }

    .void {
      color: #999999;
      text-decoration: line-through;
    }

    .el-button {
      padding: 0;
    }
  }
}
</style>